import { render, staticRenderFns } from "./dockSummary.vue?vue&type=template&id=d62c14ec&scoped=true"
import script from "./dockSummary.vue?vue&type=script&lang=js"
export * from "./dockSummary.vue?vue&type=script&lang=js"
import style0 from "./dockSummary.vue?vue&type=style&index=0&id=d62c14ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62c14ec",
  null
  
)

export default component.exports